import axios from "axios";
import { takeEvery, call, put, select } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { queryParams } from "../../../../../utils/queryParams.js";
import moment from "moment/moment";

export const SET_LOADING = "saga/SET_LOADING";
export const SET_CONSTANTS = "saga/SET_CONSTANTS";
export const SET_FILTERS_LOADING = "saga/SET_FILTERS_LOADING";
export const SET_ALL_SITES_MODE = "saga/SET_ALL_SITES_MODE";
export const TOGGLE_VIEW = "saga/TOGGLE_VIEW";
export const FETCH_MODULE = "saga/FETCH_MODULE";
export const FETCH_FILTERS = "saga/FETCH_FILTERS";
export const UPDATE_REFERRAL_TOGGLE = "saga/UPDATE_REFERRAL_TOGGLE";
export const UPDATE_FILTERS = "saga/UPDATE_FILTERS";
export const UPDATE_MODULE = "saga/UPDATE_REFERRAL_CATEGORIES";
// keep it small to match reducer names and tags from backend props
export const LEAD_CONVERSION = "leadConversion";
export const NUM_OF_INTROS = "numOfIntros";
export const INTRO_REVENUE = "introRevenue";

export const actionCreators = (moduleName) => ({
  fetchData: createAction(FETCH_MODULE + moduleName),
  updateData: createAction(UPDATE_MODULE + moduleName),
  toggleView: createAction(TOGGLE_VIEW + moduleName),
  updateFilters: createAction(UPDATE_FILTERS + moduleName),
  updateReferralToggle: createAction(UPDATE_REFERRAL_TOGGLE + moduleName)
});

export default function* watchStars(moduleName) {
  yield takeEvery(FETCH_MODULE + moduleName, fetchData);
  yield takeEvery(UPDATE_MODULE + moduleName, updateData);
  yield takeEvery(TOGGLE_VIEW + moduleName, toggleView);
  yield takeEvery(UPDATE_FILTERS + moduleName, updateFilters);
}

export function apiCall(route, params, method = axios.get) {
  return call(
    method,
    queryParams.apiVersion +
      route +
      Object.keys(params).reduce(
        (res, propName) => res + propName + "=" + params[propName] + "&",
        "?"
      )
  );
}

export function* fetchData({ payload }) {
  const { moduleName } = payload;
  yield put({ type: SET_LOADING + "/" + moduleName, payload: true });
  // adding constants (that contain organizationId, objectId, dataPath ...) to reducers on initial fetch
  yield put({
    type: SET_CONSTANTS + "/" + moduleName,
    payload: payload
  });
  const { commonParams, filtersPath, dataPath } = yield getApiParams(moduleName);
  let params = {
    ...commonParams
  };

  try {
    const { start_date, end_date } = yield fetchFilters({
      payload: {
        moduleName,
        params,
        filtersPath
      }
    });

    params = { ...params, start_date, end_date };

    const { data } = yield apiCall(dataPath, params);

    yield put({
      type: FETCH_MODULE + "/" + moduleName,
      payload: data.data ? data.data : data
    });
  } catch (error) {
    console.error(error);
  }
}

export function* updateData({ payload }) {
  const { moduleName, filters } = payload;
  yield put({ type: SET_LOADING + "/" + moduleName, payload: true });

  const { commonParams, dataPath, table_view } = yield getApiParams(moduleName);
  try {
    const { startDate: start_date, endDate: end_date, periodType } = filters;

    const params = {
      ...commonParams,
      start_date,
      end_date,
      table_view,
      period_type: periodType.toLowerCase()
    };

    const { data } = yield apiCall(dataPath, params);

    yield put({
      type: FETCH_MODULE + "/" + moduleName,
      payload: data.data ? data.data : data
    });
  } catch (error) {
    console.error(error);
  }
}

export function* fetchFilters({ payload }) {
  const { moduleName, params, filtersPath } = payload;
  const {
    data: { filters }
  } = yield apiCall(filtersPath, params);

  yield put({ type: FETCH_FILTERS + "/" + moduleName, payload: filters });
  return filters;
}

export function* updateFilters({ payload }) {
  const { moduleName, ...rest } = payload;

  yield put({ type: UPDATE_FILTERS + "/" + moduleName, payload: rest });
}

export function* getApiParams(moduleName) {
  const { organization_id, short_url } = yield select((state) => state.commonReducer.commonProps);
  const { calendarEndDate, filtersPath, dataPath, isTable } = yield select(
    (state) => state[moduleName]
  );

  const startDate = moment(calendarEndDate)
    .startOf("month")
    .subtract(11, "month")
    .format("YYYY-MM-DD");
  return {
    commonParams: {
      organization_id,
      short_url,
      start_date: startDate,
      end_date: calendarEndDate
    },
    dataPath,
    table_view: isTable,
    filtersPath
  };
}

export function* toggleView({ payload }) {
  const { moduleName, view } = payload;
  yield put({ type: TOGGLE_VIEW + "/" + moduleName, payload: view });
  yield updateData({ payload });
}
